export enum HdcMembershipStatus {
  OK = 'OK',
  HAS_MEMBERSHIP = 'ALREADY_HAS_MEMBERSHIP',
  ACTIVE = 'ACTIVE',
  MEMBER_NOT_FOUND = 'MemberNotFoundError',
}
